export { SkipToContent, type SkipToContentProps } from './skip-to-content';
